import Splide from '@splidejs/splide';

export default function init(container: HTMLElement) {
    const splide = container.querySelector('.splide') as HTMLElement;

    function initSplide(slider: HTMLElement) {
        const sliderNode = new Splide(slider, {
            type: 'slide',
            arrows: false,
            pagination: false,
            rewind: true,
            gap: '20px',
            fixedWidth: '290px',
            drag: false,
            breakpoints: {
                1340: {
                    drag: true,
                },
            },
        });
        sliderNode.mount();
    }

    if (splide != null) {
        initSplide(splide);
    }
}
